import type { ReactNode } from "react";

type TopicCardGridProps = {
  children: ReactNode;
};

export function TopicCardGrid({ children }: TopicCardGridProps) {
  return (
    <div className="not-prose grid gap-5 sm:grid-cols-2">{children}</div>
  );
}
